const DEFAULT_LIMIT = 10000;
const DEFAULT_SKIP = 0;
import moment from 'moment'

const defaultState = {
	data: [],
	filter: {
		limit: DEFAULT_LIMIT,
		skip: DEFAULT_SKIP
	}
};

function listSummaries(state = defaultState, action) {
	switch (action.type) {
		case 'RESET_STATE':
			return defaultState;
		case 'GET_ALL_SUMMARIES_SUCCESS': {
			try {
			const getOnce = action.payload.data[0];
			let data = action.payload.data.filter(snap => snap.account.status === action.filter.where.status);
			let mapData = [];
			let client = [];
			let listMonth = [];
			data.map(snap => {
				if (snap.account) {
					// hide total equal 0
					if (snap.subscription + snap.makingData + snap.removal + snap.pdMeasurement + snap.other === 0) return
					// hide haven't fill client name yet
					if (!snap.account.clientName) return
					const date = moment(snap.created).format('YYYY-MM')
					if (!listMonth.includes(date)) {
						listMonth.push(date)
					}
					const info = {
						id: snap.id,
						number: snap.number,
						totalModel: snap.totalModel,
						subscription: snap.subscription,
						makingData: snap.makingData,
						removal: snap.removal,
						pdMeasurement: snap.pdMeasurement,
						pdMeasurementDuration: snap.pdMeasurementDuration,
						accountStatus: snap.accountStatus,
						payment: snap.payment,
						note: snap.note,
						other: snap.other,
						paymentType: snap.paymentType,
						invoiceId: snap.invoiceId,
						paypalInvoiceId: snap.paypalInvoiceId,
						paypalInvoiceStatus: snap.paypalInvoiceStatus,
						created: snap.created,
					}
					if (client.includes(snap.account.clientName)) {
						const index = client.indexOf(snap.account.clientName)
						mapData[index].monthly = {
							...mapData[index].monthly,
							[date]: info
						}
					} else {
						client.push(snap.account.clientName)
						mapData.push({
							id: snap.account.id,
							email: snap.account.email,
							clientName: snap.account.clientName,
							representativeName: snap.account.representativeName,
							representativeEmail: snap.account.representativeEmail,
							representativeCC: snap.account.representativeCC,
							invoicePostfix: snap.account.invoicePostfix,
							address: snap.account.address,
							current: snap.account.currency,
							makingDataUP: snap.account.makingDataUP,
							removalUP: snap.account.removalUP,
							paymentType: snap.account.paymentType,
							monthly: {
								[date]: info
							},
						})
					}
				}
			})
			data = mapData
			const total = action.payload.total
			return {
				...state,
				data,
				listMonth,
				getOnce,
				total
			};
		} catch (err) {
			console.log(err)
			return defaultState
		}
		}
		case 'EXPORT_CSV_SUCCESS': {
			const listExport = action.payload.data
			return {
				...state,
				listExport
			};
		}
		case 'EDIT_SUMMARY_SUCCESS': {
      return {
        ...state,
      }
    }
		case 'GET_INVOICE_LIST_SUCCESS':
			const listInvoice = action.payload
      return {
				...state,
				listInvoice
			}
		default:
			return state;
	}
}

export default listSummaries;



// WEBPACK FOOTER //
// ./routes/admin/routes/summary-list/reducer/list.js